import type { FiltrosBot, FunilBot, FunisBot } from '@/services/api/analytics-bot';
import { n, pct, TRACO, usd, usd4 } from '../format';
import Avisos from './Avisos';
import EstadoBloco from './EstadoBloco';

const GF = 'minmax(220px,1.6fr) 92px 84px 88px 84px 66px 84px 104px 92px 118px';

interface ListaFunisProps {
    dados: FunisBot | undefined;
    filtros: FiltrosBot;
    de: string;
    ate: string;
    rotulo: string;
    carregando: boolean;
    atualizando: boolean;
    erro: boolean;
    onTentar: () => void;
}

const SemRastreio = () => <span className="semrec">sem rastreio</span>;

const nomesPaginas = (f: FunilBot) => {
    const nomes = f.paginas.map(p => p.nome || p.page_id);
    return nomes.length > 3 ? `${nomes.slice(0, 3).join(', ')} +${nomes.length - 3}` : nomes.join(', ');
};

/** Lista de funis: a análise por mensagem é a do Flow, aberta com o mesmo período e página. */
export default function ListaFunis({
    dados, filtros, de, ate, rotulo, carregando, atualizando, erro, onTentar,
}: ListaFunisProps) {
    const funis = dados?.funis ?? [];
    const abrirNoFlow = (id: number) => {
        const q = new URLSearchParams({ detalhes: '1', de, ate });
        if (filtros.pagina_id) q.set('pagina', filtros.pagina_id);
        window.open(`/meta/flow/${id}?${q.toString()}`, '_blank', 'noopener');
    };
    const naoAtribuida = dados?.receita_nao_atribuida;

    return (
        <div className="card">
            <div className="card-h">
                <div>
                    <div className="card-t">Funis · {rotulo}</div>
                    <div className="card-s">Clique num funil para abrir o Flow com os detalhes do período e da página selecionados.</div>
                </div>
                {dados && <div className="card-s">Receita de flow no período: <b className="rev">{usd(dados.receita_flow_total)}</b></div>}
            </div>

            {!dados ? (
                <EstadoBloco carregando={carregando} erro={erro} onTentar={onTentar} />
            ) : funis.length === 0 ? (
                <div className="empty">Nenhum funil roda com esse recorte de filtros.</div>
            ) : (
                <div className="lst" data-loading={atualizando ? 1 : 0}>
                    <div>
                        <div className="lst-head" style={{ gridTemplateColumns: GF }}>
                            <span>Funil</span><span>Tipo</span><span>Entrantes</span><span>Entregues</span>
                            <span>Cliques</span><span>CTR</span><span>Conclusão</span><span>Receita</span><span>RPC</span><span />
                        </div>
                        {funis.map(f => {
                            const sem = !f.rastreio_receita;
                            return (
                                <div className="item" key={f.id} data-open={0}>
                                    <div className="lst-row" style={{ gridTemplateColumns: GF }} onClick={() => abrirNoFlow(f.id)}>
                                        <div className="nm" title={f.nome}>
                                            {f.nome}{sem && <span className="pill" data-t="off">sem utm</span>}
                                            <small>#{f.id} · {nomesPaginas(f) || 'sem página'}</small>
                                        </div>
                                        <div>
                                            <span className="pill" data-t={f.tipo === 'onboarding' ? 'run' : 'wait'} style={{ margin: 0 }}>{f.tipo === 'sequencia' ? 'sequência' : 'onboarding'}</span>
                                        </div>
                                        <div className="num">{n(f.entrantes)}</div>
                                        <div className="num">{n(f.entregues)}</div>
                                        <div className="num" style={{ fontWeight: 620 }}>{n(f.cliques)}</div>
                                        <div className="num" style={{ color: 'var(--violet)' }}>{pct(f.ctr_pct, 1)}</div>
                                        <div className="num">{pct(f.conclusao_pct, 1)}</div>
                                        <div className="num rev">{sem ? <SemRastreio /> : usd(f.receita)}</div>
                                        <div className="num muted">{sem ? <SemRastreio /> : usd4(f.rpc)}</div>
                                        <div>
                                            <button className="mini" onClick={e => { e.stopPropagation(); abrirNoFlow(f.id); }}>
                                                abrir no flow ↗
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                        <div className="item" data-open={0} data-fixed={1}>
                            <div className="lst-row" style={{ gridTemplateColumns: GF }}>
                                <div className="nm">
                                    Não atribuído
                                    <small>receita de flow que não se liga a nenhum funil listado</small>
                                </div>
                                <div /><div className="num muted">{TRACO}</div><div className="num muted">{TRACO}</div>
                                <div className="num muted">{TRACO}</div><div className="num muted">{TRACO}</div><div className="num muted">{TRACO}</div>
                                <div className="num rev">{usd(naoAtribuida)}</div>
                                <div className="num muted">{TRACO}</div><div />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Avisos avisos={dados?.avisos} />
        </div>
    );
}
